$(document).ready(function () {
  const $container = $('.featured-collections');
  if ($container.length === 0) return;

  const $content       = $container.find('.product-list .product-list__inner--scroller');
  const $scrollContent = $container.find('.product-list .scroller');
  const $thumb         = $container.find('.scroll-thumb');
  const $scrollbar     = $container.find('.custom-scrollbar');

  //gsap.registerPlugin(ScrollToPlugin);
  
  let thumbDraggable = null;

  function setupScrollbar() {
    var scrollWidth = $content[0].scrollWidth;
    // var containerWidth = $content.width();
    // var maxScrollLeft = scrollWidth - containerWidth;

    var thumbWidth = 70;
    var maxThumbX = $scrollbar.width() - thumbWidth;
    var windowWidth = $(window).width();

    let syncing = true; // toggle flag

    if (thumbDraggable) {
      thumbDraggable.kill();
      thumbDraggable = null;
    }

    /** Convert scrollLeft → thumbX */
    function scrollToThumb(scrollLeft) {
      return (scrollLeft / (scrollWidth - windowWidth)) * maxThumbX;
    }

    /** Convert thumbX → scrollLeft */
    function thumbToScroll(thumbX) {
      return ((thumbX / maxThumbX) * (scrollWidth - windowWidth));
    }

    $scrollContent.on("scroll", function () {
      if (!syncing) return; // prevent updates during dragging
      gsap.set($thumb, { x: scrollToThumb(this.scrollLeft) });
    });

    // Draggable
    thumbDraggable = Draggable.create($thumb[0], {
      type: 'x',
      bounds: { minX: 0, maxX: maxThumbX },
      onDragStart() { syncing = false; },
      onDragEnd() { syncing = true;  },
      onDrag: function () {
        syncing = false;
        $scrollContent[0].scrollLeft = thumbToScroll(this.x);
      }
    })[0];
  }

  setupScrollbar();

  $(window).on('resize', setupScrollbar);
});

$(document).ready(function () {
  $(document).on('input change', '.quantity-selector__input', function(event) {
    handleQuantityChange($(this), event);
  });
  function handleQuantityChange(element, event) {
    let quantity = element.val() || 1;
    let parent = element.parents('.product__info');
    let priceElement = parent.find('.price-list');
    let currency = priceElement.data('currency');
    let price = priceElement.data('price');
    let total = (price * quantity) / 100;
    $('#AddToCart .btn-price').html(`${currency}${total.toFixed(2)}`);
    console.log('Quantity changed to:', quantity, event.type, currency, price);
  }

  $(document).on('change', '.blog-tag-filter input[name="blog_filter"]', function(){
    window.location.href = $(this).val();
  });

  const container = document.querySelector('.logo-list--carousel');
  const productContainer = document.querySelector('.logoList_product');
  let direction = -1; // 1 for right, -1 for left
  const speed = 1;   // pixels per frame
  var lastScrollLeft = 0;
  function autoScroll() {
    if (window.innerWidth < 950) 
    {
      if (container) {
        // console.log("autoscroll");
        let padding = $('.logo-list--carousel').offset().left;
        let clientWidth = $('.logo-list--carousel').innerWidth();
        let windowWidth = window.innerWidth - (24 * 2);
        let left = parseFloat(container.style.left || 0);
        let shift = direction * speed;
        let currentLeft = left + shift;
        container.style.left = `${currentLeft}px`;
        
        // Reverse direction at ends
        if ((Math.abs(currentLeft) >= (clientWidth - windowWidth) && direction == -1) || (currentLeft >= 0 && direction == 1)) {
          direction *= -1;
        }
      }else if (productContainer) {
        let shift = direction * speed;
        productContainer.scrollLeft += shift;
        if ((productContainer.scrollLeft == 0 && direction == -1) || (direction == 1 && productContainer.scrollLeft >= (productContainer.scrollWidth - productContainer.clientWidth))) {
          direction *= -1;
        }
      }
    }else{
      if (container) {
        container.style.left = `0px`;
      }else if (productContainer) {
        productContainer.scrollLeft = 0;
      }
    }
    requestAnimationFrame(autoScroll);
  }

  autoScroll(); // Start auto-scrolling
}); 